const FTPFields = {
  TransferType: {
    fieldKey: "TransferType",
    element: "radio",
    title: "TransferType",
    label: "ftp-transfer-type",
    placeholder: "ftp-transfer-type",
    tooltip: {
      text: "ftp-transfer-type-tooltip",
      icon: "question-circle",
    },
    optionsList: [
      { value: "zip", label: "ftp-transfer-as-zip-label" },
      { value: "unzip", label: "ftp-transfer-as-open-folder-label" },
    ],
    validation: {
      required: true,
      invalidMessage: "ftp-transfer-require-text",
    },
  },
  Protocol: {
    fieldKey: "Protocol",
    element: "radio",
    title: "Protocol",
    label: "ftp-protocol",
    tooltip: {
      text: "ftp-protocol-tooltip",
      icon: "question-circle",
    },
    optionsList: [
      { value: "ftp", label: "FTP" },
      { value: "ftps", label: "FTPS" },
    ],
    placeholder: "ftp-protocol",
    validation: {
      required: true,
      invalidMessage: "ftp-protocol-require",
    },
    //containerClassName: "input",
  },
  FtpHostAddress: {
    fieldKey: "FtpHostAddress",
    element: "input",
    type: "text",
    title: "FtpHostAddress",
    label: "ftp-host-address",
    placeholder: "ftp-host-address",
    tooltip: {
      text: "ftp-host-tooltip",
      icon: "question-circle",
    },
    validation: {
      required: true,
      reg: /[^\n]+/,
      invalidMessage: "invalid-host-require",
    },
  },
  FtpFolder: {
    fieldKey: "FtpFolder",
    element: "input",
    type: "text",
    title: "FtpFolder",
    label: "ftp-folder",
    placeholder: "ftp-folder",
    tooltip: {
      text: "ftp-folder-tooltip",
      icon: "question-circle",
    },
  },
  Mode: {
    fieldKey: "Mode",
    element: "radio",
    title: "Mode",
    label: "ftp-mode",
    placeholder: "ftp-mode",
    tooltip: {
      text: "ftp-mode-tooltip",
      icon: "question-circle",
    },
    optionsList: [
      { value: "passive", label: "ftp-passive-label" },
      { value: "active", label: "ftp-active-label" },
    ],
    validation: {
      required: true,
      invalidMessage: "ftp-mode-require-text",
    },
  },
  FtpUsername: {
    fieldKey: "FtpUsername",
    element: "input",
    type: "text",
    title: "off",
    label: "ftp-username",
    placeholder: "ftp-username",
    tooltip: {
      text: "ftp-username-tooltip",
      icon: "question-circle",
    },
    validation: {
      required: true,
      reg: /[^\n]+/,
      invalidMessage: "invalid-username-require",
    },
  },
  FtpPassword: {
    fieldKey: "FtpPassword",
    element: "input",
    type: "password",
    title: "off",
    label: "ftp-password",
    placeholder: "ftp-password",
    hidePassStrength: true,
    tooltip: {
      text: "ftp-password-tooltip",
      icon: "question-circle",
    },
    validation: {
      required: true,
      invalidMessage: "invalid-password-require",
      reg: /[^\n]+/,
      maxLength: 50,
    },
  },
  FtpPort: {
    fieldKey: "FtpPort",
    element: "input",
    type: "text",
    title: "FtpPort",
    label: "ftp-port",
    placeholder: "ftp-port",
    tooltip: {
      text: "ftp-port-tooltip",
      icon: "question-circle",
    },
    validation: {
      required: true,
      reg: /[^\n]+/,
      invalidMessage: "invalid-port-require",
    },
  },
};

export default FTPFields;
